export const sg_Button = {
    background: "#6b9add",
}


// WEBPACK FOOTER //
// ./src/Utils/Styles.js